import ACTIONS from "../actions/types";

const initialState = {
  blockReview: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_PAGE_IDS:
      return {
        ...state,
        ...action.payload,
      };
    // case ACTIONS.SET_REVIEWER_EXPIRE_DATE:
    //   return {
    //     ...state,
    //     expiresAt: action.payload,
    //   };

    default:
      return state;
  }
}
